import React from 'react';
import { useTranslation } from 'react-i18next';
import Accounts from '../../TabsComponent/FinancialInfo/tabs/Accounts';
import NegativeInfo from '../../TabsComponent/FinancialInfo/tabs/NegativeInfo';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.financialInfo';

const FinancialInfoPrint = ({ financial, itemsToExport }) => {
  const { t: translate } = useTranslation();

  if (!itemsToExport.value) return <></>;

  return (
    <div className="to-print-company-details">
      <h2>{translate(`${I18N_BASE_PATH}.tabs.financial`, 'Financial')}</h2>

      {itemsToExport.items.accounts.value && (
        <>
          <h3>{translate(`${I18N_BASE_PATH}.tabs.accounts.title`, 'Accounts')}</h3>
          <Accounts
            className="to-print-company-details"
            financialData={financial}
            collapseKeyPrefix="print"
            bordered={false}
            showArrow={false}
            collapseOpened
          />
        </>
      )}

      {itemsToExport.items.negativeInformations.value && (
        <>
          <h3>
            {translate(`${I18N_BASE_PATH}.tabs.negativeInfo.title`, 'Negative info')}
          </h3>
          <NegativeInfo
            className="to-print-company-details"
            financialData={financial}
            collapseKeyPrefix="print"
            bordered={false}
            showArrow={false}
            collapseOpened
          />
        </>
      )}
    </div>
  );
};

export default FinancialInfoPrint;
